import React, { useState, useEffect, useRef } from 'react';
import store from "../../store";
import { connect, useDispatch } from "react-redux";
import { renderImg } from '../common/icons/img';
import {
    updateFilterBusService,
    updateFilterCoach,
    updateFilterJourneyType,
    updateFilterTime,
    updateRoutesPkpDrp,
    updateFilterBoardingPoint,
    updateFilterDroppingPoint,
    updateFilterPriceRange,
    updateFilterLayoverRange,
    updateLoader
} from '../../actions/search-actions';
import CheckBox from '../common/checkbox';
import { fetchGet, getRevDate } from '../../common/common';
import { apiUrl } from '../common/constants';
import RangeSlider from '../common/RangeSlider';
import LineInput from '../common/lineinput';
import { t, FILTER_BY, CLEAR_ALL,JOURNEY_TYPE,MIN_LAYOVER_TIME, BUT_TYPE, DEPARTURE_TIME, SERVICE_CLASS, BOARDING_POINTS, DROPPING_POINTS, PRICE_RANGE, MIN_PRICE, MAX_PRICE,MIN_HRS,MAX_HRS, TO } from '../../translations/Filter';

const Filter = () => {
    const props = store.getState();
    const [busTimeSel, setbusTimeSel] = useState([false, false, false, false]);
    const [busSel, setBusSel] = useState([false, false, false, false, false, false]);
    const [journeyTypeSel, setJourneyTypeSel] = useState('Direct Bus');
    const [journeyType, selJourneyType] = useState([{ label: 'Direct Bus', icon: 'dbus' }, { label: 'Connect Bus', icon: 'cbus' }]);
    const [busType, selBusType] = useState([{ label: 'AC', icon: 'ac' }, { label: 'Non AC', icon: 'ac' }, { label: 'Seater', icon: 'seater' }, { label: 'Sleeper', icon: 'sleeper' }]);
    const [busTime, selBusTime] = useState([{ label: 'Before-10AM', icon: 'morning' }, { label: '10AM - 5PM', icon: 'noon' }, { label: '5PM-11PM', icon: 'evening' }, { label: 'After-11PM', icon: 'night' }]);
    const [busServiceCheked, setServiceChecked] = useState([]);
    const [boardingPointChecked, setBoardingPointChecked] = useState([]);
    const [droppingPointChecked, setDroppingPointChecked] = useState([]);
    const [showService, setShowService] = useState(false);
    const [showBoarding, setShowBoarding] = useState(false);
    const [showDroping, setShowDropping] = useState(false);
    const [minPrice, setMinPrice] = useState(0);
    const [maxPrice, setMaxPrice] = useState(0);
    const [minFareRange, setMinFareRange] = useState(0);
    const [maxFareRange, setMaxFareRange] = useState(0);

    const [minHrs, setMinHrs] = useState(1);
    const [maxHrs, setMaxHrs] = useState(24);
    const [minHrsRange, setMinHrsRange] = useState(1);
    const [maxHrsRange, setMaxHrsRange] = useState(24);

    const childRef1 = useRef(null);
    const childRef2 = useRef(null);


    useEffect(() => {
        getSearchRoutesPkpDrp()
    }, [])

    useEffect(() => {
        setMinPrice(props.search.fareRange.min);
        setMaxPrice(props.search.fareRange.max);
        setMinFareRange(props.search.fareRange.min);
        setMaxFareRange(props.search.fareRange.max);
    }, [props.search.fareRange])

    useEffect(()=>{
        if(props.search.searchParams.linkfromstoptocity){
            setJourneyTypeSel("Connect Bus");
            store.dispatch(updateFilterJourneyType("Connect Bus"));
        }
    },[props.search.searchParams.linkfromstoptocity])

    const getSearchRoutesPkpDrp = () => {

        const { dropoffs, pdroutes, pickups } = props.search.routePkpDrp;

        if (
            dropoffs.length === 0 &&
            pickups.length === 0
        ) {
            const data = {
                fromCityID: props.search.searchParams.fromCity.split("|")[0],
                toCityID: props.search.searchParams.toCity.split("|")[0],
                journeyDate: getRevDate(props.search.searchParams.departDate),
            };
            const url = `${window.url}${apiUrl.searchPkpDrp}?fromCityID=${data.fromCityID}&toCityID=${data.toCityID}&journeyDate=${data.journeyDate}`;
            // store.dispatch(updateLoader(true));

            fetchGet(url)
                .then((data) => {
                    store.dispatch(updateLoader(false));

                    var pickupData = [];
                    var dropoffData = [];
                    var pdRouteData = {};

                    if (data && data.length > 0) {
                        data.forEach((el) => {
                            //console.log(el);
                            if (el.Pickups.length) {
                                el.Pickups.forEach((p) => {
                                    //for create pickupwise route code array
                                    if (pdRouteData[p.PN] != undefined) {
                                        pdRouteData[p.PN].push(el.RC);
                                    } else {
                                        pdRouteData[p.PN] = new Array(el.RC);
                                    }

                                    //for create pickup array
                                    if (pickupData.indexOf(p.PN) == -1) {
                                        pickupData.push(p.PN);
                                    }
                                });
                            }

                            if (el.Dropoffs.length) {
                                el.Dropoffs.forEach((d) => {
                                    //for create dropoffwise route code array
                                    if (pdRouteData[d.DN] != undefined) {
                                        pdRouteData[d.DN].push(el.RC);
                                    } else {
                                        pdRouteData[d.DN] = new Array(el.RC);
                                    }

                                    if (dropoffData.indexOf(d.DN) == -1) {
                                        dropoffData.push(d.DN);
                                    }
                                });
                            }
                        });

                        store.dispatch(
                            updateRoutesPkpDrp({
                                pickups: pickupData,
                                dropoffs: dropoffData,
                                pdroutes: pdRouteData,
                            })
                        );
                    } else {
                        store.dispatch(
                            updateRoutesPkpDrp({
                                pickups: pickupData,
                                dropoffs: dropoffData,
                                pdroutes: pdRouteData,
                            })
                        );
                    }
                })
                .catch((err) => {
                    // store.dispatch(updateLoader(false))
                    console.log(err)
                });
        }
    }

    const service = props.search.serviceTypeFilterList || [];
    const boarding = props.search.routePkpDrp.pickups || [];
    const dropping = props.search.routePkpDrp.dropoffs || [];

    const isServiceSel = busServiceCheked.indexOf(true) > -1 && !showService ? true : false;
    const isBoardingSel = boardingPointChecked.indexOf(true) > -1 && !showBoarding ? true : false;
    const isDroppingSel = droppingPointChecked.indexOf(true) > -1 && !showDroping ? true : false;

    // console.log("service", service);

    const checkBusType = (val, index, busSel) => {
        let selBusType = props.search.coach;

        if (selBusType.includes(val)) {
            busSel[index] = false;
        } else {
            busSel[index] = true;
        }
        if (!selBusType.includes(val)) {
            selBusType.push(val);
        } else {
            selBusType = selBusType.filter(function (a) {
                return val !== a;
            });
        }
        // console.log("selBusTYPE", selBusType);
        setBusSel(busSel)
        store.dispatch(updateFilterCoach(selBusType));
    };

    const checkJourneyType = (val) => {

        if(props.search.journeyType == 'Connect Bus' && val == 'Direct Bus'){

            if(props.search.searchParams.linkfromstoptocity){

                let searchParams = props.search.searchParams;
                let linkfromStopTocity = searchParams?.linkfromstoptocity;
      
                if (linkfromStopTocity) {

                    let fromCity = linkfromStopTocity.split("|")[1].trim();
                    let fromCityId = linkfromStopTocity.split("|")[0].trim();

                    let toCity = linkfromStopTocity.split("|")[5].trim();
                    let toCityId = linkfromStopTocity.split("|")[4].trim();

                    var url = `/search?mode=oneway&fromCity=${fromCityId}|${fromCity}&toCity=${toCityId}|${toCity}&departDate=${searchParams.departDate}&stationInFromCity=&stationInToCity=&IsSingleLady=${searchParams.IsSingleLady}`;
                    window.location.href = url;
                }
            }
        }

        //setJourneyTypeSel(val);
        //store.dispatch(updateFilterJourneyType(val));
    };

    const getJTIconName = (icon, val) => {
        // console.log(val);
        let i = ''
        if (props.search.journeyType === val) {
            i = `filter_${icon}_active`;
        } else {
            i = `filter_${icon}`;
        }
        return i;
    }

    const getIconName = (icon, val) => {
        // console.log(val);
        let i = ''
        if (props.search.coach.includes(val)) {
            i = `filter_${icon}_active`;
        } else {
            i = `filter_${icon}`;
        }
        return i;
    }

    const getTimeIconName = (icon, val) => {
        // console.log(val);
        let i = ''
        if (props.search.time.includes(val)) {
            i = `filter_${icon}_active`;
        } else {
            i = `filter_${icon}`;
        }
        return i;
    }


    const checkBusTime = (val, index, busTimeSel) => {
        let selBusTime = props.search.time;

        if (selBusTime.includes(val)) {
            busTimeSel[index] = false;
        } else {
            busTimeSel[index] = true;
        }
        if (!selBusTime.includes(val)) {
            selBusTime.push(val);
        } else {
            selBusTime = selBusTime.filter(function (a) {
                return val !== a;
            });
        }
        // console.log("uiwiw", selBusTime);
        setbusTimeSel(busTimeSel)
        store.dispatch(updateFilterTime(selBusTime));
    };

    const clearJourneyTypeFilter = () => {
        if(props.search.journeyType == 'Connect Bus'){
            childRef2.current.updateSliderValues([1,24]);
            setMinHrs(1);
            setMaxHrs(24);
            store.dispatch(updateFilterLayoverRange([1,24]));
        }
    }

    const clearBusTypeFilter = () => {
        for (let i = 0; i < busSel.length; i++) {
            busSel[i] = false;
        }
        setBusSel(busSel)
        store.dispatch(updateFilterCoach([]));
    }

    const resetTimeFilter = () => {
        for (let i = 0; i < busTimeSel.length; i++) {
            busTimeSel[i] = false;
        }
        setbusTimeSel(busTimeSel)
        store.dispatch(updateFilterTime([]));
    }

    const resetService = () => {
        for (let i = 0; i < busServiceCheked.length; i++) {
            busServiceCheked[i] = false;
        }
        setServiceChecked(busServiceCheked)
        store.dispatch(updateFilterBusService([]));
    }

    const resetBoarding = () => {
        for (let i = 0; i < boardingPointChecked.length; i++) {
            boardingPointChecked[i] = false;
        }
        setBoardingPointChecked(boardingPointChecked);
        store.dispatch(updateFilterBoardingPoint([]));
    }

    const resetDroppingPoint = () => {
        for (let i = 0; i < droppingPointChecked.length; i++) {
            droppingPointChecked[i] = false;
        }
        setDroppingPointChecked(droppingPointChecked)
        store.dispatch(updateFilterDroppingPoint([]));
    };

    const resetAll = () => {
        clearBusTypeFilter();
        resetTimeFilter();
        resetService();
        resetBoarding();
        resetDroppingPoint();
        clearJourneyTypeFilter();
    }

    const serviceCheck = (e, index, busServiceCheked) => {
        e.stopPropagation();
        let selBusService = props.search.serviceType;
        busServiceCheked[index] = e.target.checked;
        if (e.target.checked) {
            selBusService.push(e.target.value);
        } else {
            selBusService = selBusService.filter(function (a) {
                return e.target.value !== a;
            });
        }
        setServiceChecked(busServiceCheked)
        store.dispatch(updateFilterBusService(selBusService));
    }

    const checkBoardingPoint = (e, index, boardingPointChecked) => {
        e.stopPropagation();
        let selBoardingPoints = props.search.boardingPointFilter;
        boardingPointChecked[index] = e.target.checked;

        if (e.target.checked) {
            selBoardingPoints.push(e.target.value);
        } else {
            selBoardingPoints = selBoardingPoints.filter(function (a) {
                return e.target.value !== a;
            });
        }
        setBoardingPointChecked(boardingPointChecked);
        store.dispatch(updateFilterBoardingPoint(selBoardingPoints));
    };

    const checkDroppingPoint = (e, index, droppingPointChecked) => {
        e.stopPropagation();
        let selDropoffPoints = props.search.droppingPointFilter;
        droppingPointChecked[index] = e.target.checked;
        if (e.target.checked) {
            selDropoffPoints.push(e.target.value);
        } else {
            selDropoffPoints = selDropoffPoints.filter(function (a) {
                return e.target.value !== a;
            });
        }
        setDroppingPointChecked(droppingPointChecked)
        store.dispatch(updateFilterDroppingPoint(selDropoffPoints));
    };

    const handelMinPriceChange = (val) => {
        if (parseInt(val) <= parseInt(maxPrice)) {
            childRef1.current.updateSliderValues([+val, +maxPrice]);
        }
        setMinPrice(val);
        store.dispatch(updateFilterPriceRange([+val, +maxPrice]));
    };

    const handelMaxPriceChange = (val) => {
        if (parseInt(val) >= parseInt(minPrice)) {
            childRef1.current.updateSliderValues([+minPrice, +val]);
        }
        setMaxPrice(val);
        store.dispatch(updateFilterPriceRange([+minPrice, +val]));
    };

    const handelFareChange = (range) => {
        handelMinPriceChange(range[0]);
        handelMaxPriceChange(range[1]);
        store.dispatch(updateFilterPriceRange(range));
    };

    const handelMinPriceBlur = () => {
        if (
            parseInt(minPrice) > parseInt(maxPrice) ||
            parseInt(minPrice) < parseInt(minFareRange)
        ) {
            setMinPrice(minFareRange);
            childRef1.current.updateSliderValues([
                +minFareRange,
                +maxPrice,
            ]);
        }
    };

    const handelMaxPriceBlur = () => {
        if (
            parseInt(minPrice) > parseInt(maxPrice) ||
            parseInt(maxPrice) > parseInt(maxFareRange)
        ) {
            setMaxPrice(maxFareRange);
            childRef1.current.updateSliderValues([
                +minPrice,
                +maxFareRange,
            ]);
        }
    };

    const handelMinHrsChange = (val) => {
        if (parseInt(val) <= parseInt(maxHrs)) {
            childRef2.current.updateSliderValues([+val, +maxHrs]);
        }
        setMinHrs(val);
        store.dispatch(updateFilterLayoverRange([+val, +maxHrs]));
    };

    const handelMaxHrsChange = (val) => {
        if (parseInt(val) >= parseInt(minHrs)) {
            childRef2.current.updateSliderValues([+minHrs, +val]);
        }
        setMaxHrs(val);
        store.dispatch(updateFilterLayoverRange([+minHrs, +val]));
    };

    const handelHrsChange = (range) => {

        handelMinHrsChange(1);
        //handelMinHrsChange(range[0]);

        handelMaxHrsChange(range[1]);
        store.dispatch(updateFilterLayoverRange(range));
        
    };

     const handelMinHrsBlur = () => {
        if (
            parseInt(minHrs) > parseInt(maxHrs) ||
            parseInt(minHrs) < parseInt(minHrsRange)
        ) {
            setMinHrs(minHrsRange);
            childRef2.current.updateSliderValues([
                +minHrsRange,
                +maxHrs,
            ]);
        }
    };

    const handelMaxHrsBlur = () => {
        if (
            parseInt(minHrs) > parseInt(maxHrs) ||
            parseInt(maxHrs) > parseInt(maxHrsRange)
        ) {
            setMaxHrs(maxHrsRange);
            childRef2.current.updateSliderValues([
                +minHrs,
                +maxHrsRange,
            ]);
        }
    };

    return (
        <div className='filter--wrapper' style={(showService || showBoarding || showDroping) ? { height: '100%' } : {}}>
            <div className='filter--header'>
                <div className='icon--wrap'>
                    <div className='icon'>{renderImg('filter-web')}</div>
                    <div>{t(FILTER_BY)}</div>
                </div>
                <div onClick={resetAll}>{t(CLEAR_ALL)}</div>
            </div>
            <div className='filter--journeyType'>
                <div className='header'>
                    <div>{t(JOURNEY_TYPE)}</div>
                    <div onClick={clearJourneyTypeFilter}>{t(CLEAR_ALL)}</div>
                </div>
                <div className='content'>
                    <div className={props.search.journeyType == 'Direct Bus' ? 'wrap active' : 'wrap'} onClick={() => checkJourneyType('Direct Bus')}>
                        <div>{renderImg(getJTIconName('dbus','Direct Bus'))}</div>
                        <div className={props.search.journeyType == 'Direct Bus' ? 'active--txt' : ''}>Direct Bus</div>
                    </div>
                    <div className={props.search.journeyType == 'Connect Bus' ? 'wrap active' : 'wrap disabled'} onClick={() => checkJourneyType('Connect Bus')}>
                        <div>{renderImg(getJTIconName('cbus','Connect Bus'))}</div>
                        <div className={props.search.journeyType == 'Connect Bus' ? 'active--txt' : ''}>Connect Bus</div>
                    </div>
                </div>

                {props.search.journeyType == 'Connect Bus' && (
                  <React.Fragment>
                    <div className='header2'>
                        <div>{t(MIN_LAYOVER_TIME)}</div>
                    </div>
                    <div className='content2'>
                        <div className='price--range-inputs'>
                            <LineInput
                                type="number"
                                value={minHrs}
                                handleChange={(e) => {
                                    e.stopPropagation();
                                    handelMinHrsChange(e.target.value);
                                }}
                                onBlur={() => handelMinHrsBlur()}
                                placeholder={t(MIN_HRS)}
                                name="minprice"
                                style={{ width: "112px" }}
                                max={"5"}
                                rsicon={false}
                                disabled={true}
                            />
                            <div style={{ position: 'relative', top: '0px', padding: '8px 4px' }}>{t(TO)}</div>
                            <LineInput
                                type="number"
                                value={maxHrs}
                                handleChange={(e) => {
                                    e.stopPropagation();
                                    handelMaxHrsChange(e.target.value);
                                }}
                                onBlur={() => handelMaxHrsBlur()}
                                placeholder={t(MAX_HRS)}
                                name="maxprice"
                                style={{ width: "112px" }}
                                max={"5"}
                                rsicon={false}
                            />
                        </div>
                    </div>

                    <div className="price--range-slider">
                        <RangeSlider
                            ref={childRef2}
                            min={minHrsRange}
                            max={maxHrsRange}
                            minDistance={0}
                            selectedVal={props.search.priceRangeFilter}
                            onChange={(el) => handelHrsChange(el)}
                            disabled={props.search.searchParams.mode=="roundtrip" && props.search.searchParams.token ? false :true}
                        ></RangeSlider>
                    </div>
                    <div className="price--range-text" style={{ display: 'flex', justifyContent: 'space-between' }}>
                        <div>
                            {minHrsRange}
                            {' Hrs'}
                        </div>
                        <div>
                            {maxHrsRange}
                            {' Hrs'}
                        </div>
                    </div>
                  </React.Fragment>  
                )}

            </div>
            <div className='filter--busType'>
                <div className='header'>
                    <div>{t(BUT_TYPE)}</div>
                    <div onClick={clearBusTypeFilter}>{t(CLEAR_ALL)}</div>
                </div>
                <div className='content'>
                    {busType.map((el, index) => (
                        <div key={'bus-type'+index} className={props.search.coach.includes(el.label) ? 'wrap active' : 'wrap'} onClick={() => checkBusType(el.label, index, busSel)}>
                            <div>{renderImg(getIconName(el.icon, el.label))}</div>
                            <div className={props.search.coach.includes(el.label) ? 'active--txt' : ''}>{el.label}</div>
                        </div>
                    ))}
                </div>
            </div>
            <div className='filter--timeType'>
                <div className='header'>
                    <div>{t(DEPARTURE_TIME)}</div>
                    <div onClick={resetTimeFilter}>{t(CLEAR_ALL)}</div>
                </div>
                <div className='content'>
                    {busTime.map((el, index) => (
                        <div key={'bus-time'+index} className={props.search.time.includes(el.label) ? 'wrap active' : 'wrap'} onClick={() => checkBusTime(el.label, index, busTimeSel)}>
                            <div>{renderImg(getTimeIconName(el.icon, el.label))}</div>
                            <div className={props.search.time.includes(el.label) ? 'active--txt' : ''}>{el.label}</div>
                        </div>
                    ))}
                </div>
            </div>
            <div className={`filter--service ${isServiceSel ? 'active' : ''}`}>
                <div onClick={(e) => { setShowService(!showService) }}>
                    <div>{t(SERVICE_CLASS)}</div>
                    <div className='drop'>{isServiceSel ? renderImg('filter_down_active') : showService ? renderImg('filter_drop_down') : renderImg('filter_drop')}</div>
                </div>

                {showService &&
                    <>
                        <div className='clear' style={{ color: '#004F9E', fontWeight: '500', padding: '8px 0' }} onClick={resetService}>{t(CLEAR_ALL)}</div>
                        <div className='content' style={{ overflowY: 'scroll', height: '200px' }}>
                            {service.map((el, index) => {
                                return (
                                    <CheckBox
                                        key={"serviceType" + index}
                                        index={index}
                                        value={el}
                                        checked={busServiceCheked[index]}
                                        handleChange={(e) => serviceCheck(e, index, busServiceCheked)}
                                        showValue={el}
                                        name={"serviceType"}
                                        style={{ padding: '5px 0', cursor: "pointer", fontSize: '0.875em', fontWeight: '500', letterSpacing: '.02rem' }}
                                    />
                                );
                            })}
                        </div>
                    </>
                }

            </div>
            <div className={`filter--service ${isBoardingSel ? 'active' : ''}`} >
                <div onClick={(e) => { e.stopPropagation(); setShowBoarding(!showBoarding) }}>
                    <div>{t(BOARDING_POINTS)}</div>
                    <div className='drop'>{isBoardingSel ? renderImg('filter_down_active') : showBoarding ? renderImg('filter_drop_down') : renderImg('filter_drop')}</div>
                </div>

                {showBoarding &&
                    <>
                        <div className='clear' style={{ color: '#004F9E', fontWeight: '500', padding: '8px 0' }} onClick={resetBoarding}>{t(CLEAR_ALL)}</div>
                        <div className='content' style={{ overflowY: 'scroll', height: '200px' }}>
                            {boarding.map((el, index) => {
                                return (
                                    <CheckBox
                                        key={"boarding" + index}
                                        index={index}
                                        value={el}
                                        checked={boardingPointChecked[index]}
                                        handleChange={(e) => checkBoardingPoint(e, index, boardingPointChecked)}
                                        showValue={el}
                                        name={"boarding"}
                                        style={{ padding: '5px 0', cursor: "pointer", fontSize: '0.875em', fontWeight: '500', letterSpacing: '.02rem' }}
                                    />
                                );
                            })}
                        </div>
                    </>
                }

            </div>


            <div className={`filter--service ${isDroppingSel ? 'active' : ''}`} >
                <div onClick={(e) => { e.stopPropagation(); setShowDropping(!showDroping) }}>
                    <div>{t(DROPPING_POINTS)}</div>
                    <div className='drop'>{isDroppingSel ? renderImg('filter_down_active') : showDroping ? renderImg('filter_drop_down') : renderImg('filter_drop')}</div>
                </div>

                {showDroping &&
                    <>
                        <div className='clear' style={{ color: '#004F9E', fontWeight: '500', padding: '8px 0' }} onClick={resetDroppingPoint}>{t(CLEAR_ALL)}</div>
                        <div className='content' style={{ overflowY: 'scroll', height: '200px' }}>
                            {dropping.map((el, index) => {
                                return (
                                    <CheckBox
                                        key={"dropping" + index}
                                        index={index}
                                        value={el}
                                        checked={droppingPointChecked[index]}
                                        handleChange={(e) => checkDroppingPoint(e, index, droppingPointChecked)}
                                        showValue={el}
                                        name={"dropping"}
                                        style={{ padding: '5px 0', cursor: "pointer", fontSize: '0.875em', fontWeight: '500', letterSpacing: '.02rem' }}
                                    />
                                );
                            })}
                        </div>
                    </>
                }
            </div>
            <div className='filter--service' style={{ padding: '12px 16px' }}>
                <div>{t(PRICE_RANGE)}</div>
                <div className='content'>
                    <div className='price--range-inputs'>
                        <LineInput
                            type="number"
                            value={minPrice}
                            handleChange={(e) => {
                                e.stopPropagation();
                                handelMinPriceChange(e.target.value);
                            }}
                            onBlur={() => handelMinPriceBlur()}
                            placeholder={t(MIN_PRICE)}
                            name="minprice"
                            style={{ width: "112px" }}
                            max={"5"}
                            rsicon={true}
                        />
                        <div style={{ position: 'relative', top: '10px', padding: '8px 4px' }}>{t(TO)}</div>
                        <LineInput
                            type="number"
                            value={maxPrice}
                            handleChange={(e) => {
                                e.stopPropagation();
                                handelMaxPriceChange(e.target.value);
                            }}
                            onBlur={() => handelMaxPriceBlur()}
                            placeholder={t(MAX_PRICE)}
                            name="maxprice"
                            style={{ width: "112px" }}
                            max={"5"}
                            rsicon={true}
                        />
                    </div>
                </div>

                <div className="price--range-slider">
                    <RangeSlider
                        ref={childRef1}
                        min={minFareRange}
                        max={maxFareRange}
                        selectedVal={props.search.priceRangeFilter}
                        onChange={(el) => handelFareChange(el)}
                        disabled={false}
                    ></RangeSlider>
                </div>
                <div className="price--range-text" style={{ display: 'flex', justifyContent: 'space-between' }}>
                    <div>
                        {props.search.currency}
                        {minFareRange}
                    </div>
                    <div>
                        {props.search.currency}
                        {maxFareRange}
                    </div>
                </div>
            </div>
        </div >
    )
}

const mapStateToProps = function (store) {
    return store;
};

export default connect(mapStateToProps)(Filter);